/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { DeleteApiAlbumCollectionsIdMutationResponse, DeleteApiAlbumCollectionsIdPathParams, DeleteApiAlbumCollectionsId400, DeleteApiAlbumCollectionsId401, DeleteApiAlbumCollectionsId403, DeleteApiAlbumCollectionsId404, DeleteApiAlbumCollectionsId500 } from "../../types/DeleteApiAlbumCollectionsId.ts";
import { deleteApiAlbumCollectionsIdMutationResponseSchema } from "../../zod/AlbumCollectionSchemas/deleteApiAlbumCollectionsIdSchema.ts";

function getDeleteApiAlbumCollectionsIdUrl({ id }: { id: DeleteApiAlbumCollectionsIdPathParams["Id"] }) {
  const res = { method: 'DELETE', url: `/api/album-collections/${id}` as const }  
  return res
}

/**
 * @summary Удаление выпуска
 * {@link /api/album-collections/:Id}
 */
export async function deleteApiAlbumCollectionsId({ id }: { id: DeleteApiAlbumCollectionsIdPathParams["Id"] }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DeleteApiAlbumCollectionsIdMutationResponse, ResponseErrorConfig<DeleteApiAlbumCollectionsId400 | DeleteApiAlbumCollectionsId401 | DeleteApiAlbumCollectionsId403 | DeleteApiAlbumCollectionsId404 | DeleteApiAlbumCollectionsId500>, unknown>({ method : "DELETE", url : getDeleteApiAlbumCollectionsIdUrl({ id }).url.toString(), ... requestConfig })  
  return deleteApiAlbumCollectionsIdMutationResponseSchema.parse(res.data)
}